// extracted by mini-css-extract-plugin
export default {"operationArea":"List_operationArea__wAQsM"};